<div class="modal-content">
  <div class="modal-header">
    <h3>Editar bibtex</h3>
    <h5 class="modal-title">{{ name }}</h5>
  </div>
  <div class="modal-body">
    <p class="text-red">Sempre insira as novas referencias no final do texto</p>
    <mat-progress-spinner class="mx-auto" *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>
    <textarea class="bibtex" rows="20" [(ngModel)]="bibtex"></textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="activeModal.dismiss()">Voltar</button>
    <button type="submit" btnloader (click)="onSubmit()" class="btn btn-primary">
      Salvar
    </button>
  </div>
</div>